import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  actionItemContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles
